'use client';

import { usePathname } from 'next/navigation';
import type { PropsWithChildren } from 'react';
import { Sidebar } from './sidebar';
import { Header } from './header';
import NextTopLoader from 'nextjs-toploader';
import { UiScaleProvider } from './ui-scale';

/**
 * Wrapper который условно рендерит dashboard layout
 * Для auth страниц (/login, /register) показывает только children
 * Для остальных страниц показывает Sidebar + Header + children
 */
export function LayoutWrapper({ children }: PropsWithChildren) {
  const pathname = usePathname();
  
  // Публичные страницы без dashboard chrome
  const isAuthPage = pathname === '/login' || pathname === '/register';
  const mainClass = 'isolate w-full px-6 py-4 md:px-8 md:py-6 2xl:px-10 2xl:py-8 4xl:px-8 4xl:py-10';

  if (isAuthPage) {
    return <>{children}</>;
  }

  return (
    <>
      <NextTopLoader color="#5750F1" showSpinner={false} />
      <UiScaleProvider>
      <div className="flex min-h-screen" style={{ minHeight: 'var(--otan-ui-viewport-height, 100dvh)' }}>
        <Sidebar />
        <div className="min-w-0 w-full bg-gray-2 dark:bg-[#020d1a]">
          <Header />
          <main className={mainClass}>
            {children}
          </main>
        </div>
      </div>
      </UiScaleProvider>
    </>
  );
}
